import { useCallback, useMemo, useState } from 'react';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from '../../context-menu';
import { EditorStarterItem } from '../../items/item-type';
import { setSelectedItems } from '../../state/actions/set-selected-items';
import { useWriteContext } from '../../utils/use-context';
import { TimelineItemContextMenu } from './timeline-item-context-menu';
import { SilenceReviewDialog } from '../silence-review-dialog';

export const ItemContextMenuTrigger = ({
  item,
  children,
}: {
  item: EditorStarterItem;
  children: React.ReactNode;
}) => {
  const { setState } = useWriteContext();
  const [removeSilenceDialogOpen, setRemoveSilenceDialogOpen] = useState(false);
  const [silenceTargetIds, setSilenceTargetIds] = useState<string[]>([]);

  const handleContextMenu = useCallback(() => {
    setState({
      update: (state) => {
        if (state.selectedItems.length > 1) {
          return state;
        }
        return setSelectedItems(state, [item.id]);
      },
      commitToUndoStack: false,
    });
  }, [item.id, setState]);

  const handleRequestRemoveSilenceDialog = useCallback(
    (itemIds: string[]) => {
      setSilenceTargetIds(itemIds);
      // ContextMenu onSelect가 flushSync로 동기 처리되므로,
      // ContextMenu의 DismissableLayer가 완전히 정리된 뒤에 Dialog를 열어야
      // 포인터 이벤트 충돌이 발생하지 않는다.
      requestAnimationFrame(() => {
        setRemoveSilenceDialogOpen(true);
      });
    },
    [],
  );

  const style = useMemo(() => {
    return {
      display: 'contents',
    };
  }, []);

  return (
    <>
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <div
            onContextMenu={handleContextMenu}
            style={style}
          >
            {children}
          </div>
        </ContextMenuTrigger>
        <ContextMenuContent>
          <TimelineItemContextMenu
            item={item}
            onRequestRemoveSilenceDialog={handleRequestRemoveSilenceDialog}
          />
        </ContextMenuContent>
      </ContextMenu>
      {removeSilenceDialogOpen && <SilenceReviewDialog
        open={removeSilenceDialogOpen}
        onOpenChange={setRemoveSilenceDialogOpen}
        itemIds={silenceTargetIds}
      />}
    </>
  );
};
